import React from 'react';
import { Check } from 'lucide-react';
export function Pricing() {
  const plans = [{
    name: 'STARTER',
    price: '2,500',
    limit: 'UP TO 50k PLN SPEND',
    features: ['Weekly Reports', 'Basic Automation', 'Email Support']
  }, {
    name: 'GROWTH',
    price: '7,500',
    limit: 'UP TO 200k PLN SPEND',
    features: ['Daily Reports', 'Full Automation', 'Slack Access', 'Creative Strategy'],
    highlight: true
  }, {
    name: 'SCALE',
    price: '15,000',
    limit: 'UNLIMITED SPEND',
    features: ['Real-time Dashboard', 'Custom API Access', '24/7 Priority', 'Dedicated Strategist', 'Quarterly Audits']
  }];
  return <section className="border-b-2 border-black" data-id="element-73">
      <div className="grid grid-cols-1 lg:grid-cols-3" data-id="element-74">
        {plans.map((plan, i) => <div key={plan.name} className={`
              flex flex-col
              ${i !== plans.length - 1 ? 'border-b-2 lg:border-b-0 lg:border-r-2 border-black' : ''}
              ${plan.highlight ? 'bg-black text-white' : 'bg-white text-black'}
            `} data-id="element-75">
            <div className={`p-8 border-b-2 ${plan.highlight ? 'border-white' : 'border-black'}`} data-id="element-76">
              <h3 className="text-xl font-bold mb-2" data-id="element-77">{plan.name}</h3>
              <div className="flex items-baseline gap-1" data-id="element-78">
                <span className="text-4xl font-bold" data-id="element-79">{plan.price}</span>
                <span className="text-sm" data-id="element-80">PLN/MO</span>
              </div>
              <div className={`mt-4 text-sm font-bold py-1 px-2 inline-block border ${plan.highlight ? 'border-white text-white' : 'border-black text-black'}`} data-id="element-81">
                {plan.limit}
              </div>
            </div>

            <div className="p-8 flex-1 flex flex-col justify-between" data-id="element-82">
              <ul className="space-y-4 mb-8" data-id="element-83">
                {plan.features.map(feature => <li key={feature} className="flex items-start gap-3" data-id="element-84">
                    <Check className={`w-5 h-5 shrink-0 ${plan.highlight ? 'text-[#ff0000]' : 'text-black'}`} data-id="element-85" />
                    <span className="text-sm font-medium" data-id="element-86">{feature}</span>
                  </li>)}
              </ul>

              <button className={`
                w-full py-4 text-center font-bold text-lg border-2 transition-all
                ${plan.highlight ? 'border-white bg-white text-black hover:bg-[#ff0000] hover:border-[#ff0000] hover:text-white' : 'border-black bg-black text-white hover:bg-[#ff0000] hover:border-[#ff0000] hover:text-white'}
              `} data-id="element-87">
                SELECT PLAN
              </button>
            </div>
          </div>)}
      </div>
    </section>;
}